export const ASK_LOCATION_PERMISSION_REQUEST = 'permission/ASK_LOCATION_PERMISSION_REQUEST';
export const ASK_LOCATION_PERMISSION_SUCCESS = 'permission/ASK_LOCATION_PERMISSION_SUCCESS';
export const ASK_LOCATION_PERMISSION_FAILURE = 'permission/ASK_LOCATION_PERMISSION_FAILURE';

export const LOAD_LOCATION_PERMISSION_STATUS_REQUEST = 'permission/LOAD_LOCATION_PERMISSION_STATUS_REQUEST';
export const LOAD_LOCATION_PERMISSION_STATUS_SUCCESS = 'permission/LOAD_LOCATION_PERMISSION_STATUS_SUCCESS';
export const LOAD_LOCATION_PERMISSION_STATUS_FAILURE = 'permission/LOAD_LOCATION_PERMISSION_STATUS_FAILURE';
